import React from 'react';
import { WEEKDAYS_SHORT } from '../../lib/dashboard/helpers';

export const WeekBars = ({ weekBars }) => {
  const maxBar = Math.max(...weekBars, 1);
  return (
    <div className="panel" data-testid="week-chart">
      <div className="ph"><h3>Bookings this week</h3></div>
      <div className="chart">
        <div className="bars">
          {weekBars.map((v, i) => (
            <div key={i} className="col">
              <div className="stk" style={{ height: 110 }}>
                <div className="fill" style={{ height: `${(v / maxBar) * 100}%` }} />
              </div>
              <span>{WEEKDAYS_SHORT[(i + 1) % 7]}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const ChannelSplit = ({ channels }) => (
  <div className="panel" data-testid="channel-panel">
    <div className="ph"><h3>Booking channel</h3></div>
    <div className="prog">
      <div className="progrow">
        <div className="lab"><b>Web</b><span>{channels.webPct}%</span></div>
        <div className="track"><div className="fl" style={{ width: `${channels.webPct}%`, background: 'var(--acc)' }} /></div>
      </div>
      <div className="progrow">
        <div className="lab"><b>Walk-in / manual</b><span>{channels.manualPct}%</span></div>
        <div className="track"><div className="fl" style={{ width: `${channels.manualPct}%`, background: 'var(--green)' }} /></div>
      </div>
      <div className="progrow">
        <div className="lab"><b>Returning rebooks</b><span>{channels.rebookPct}%</span></div>
        <div className="track"><div className="fl" style={{ width: `${channels.rebookPct}%`, background: 'var(--amber)' }} /></div>
      </div>
    </div>
  </div>
);
